<div class="mainDiv">
    <p class="text">Vous n'êtes pas autorisé à accéder à l'application. Merci de vous rapprocher du directeur opérationnel de votre filiale ou de la DSI Île-de-France</p>
</div>
